const drawDashedLine = (
  ctx: CanvasRenderingContext2D,
  centerX: number,
  centerY: number,
  x: number,
  y: number,
  isHovered: boolean
) => {
  ctx.beginPath();
  ctx.setLineDash([4, 4]);
  ctx.moveTo(centerX, centerY);
  ctx.lineTo(x, y);
  ctx.strokeStyle = isHovered ? "#fdbb2c" : "#555";
  ctx.stroke();
  ctx.closePath();
};

export default drawDashedLine;
